export default __webpack_public_path__ + "static/premio_exlclusivo-CO-51f77932ce1b27535138e65bd9f4dff8.png";